import { cn } from "./lib/cn";

export interface StepperProps {
  steps: readonly string[];
  /** Aktif adımın 0 tabanlı sırası. */
  current: number;
  className?: string;
}

/**
 * Adım göstergesi — mockup "Yeni Sözleşme" sihirbazları (Şablon Seç → Temel Bilgiler → …).
 *
 * ⚠ SAHTE ADIM YASAK (spec §7.3): bir akış tek formdan oluşuyorsa bu bileşen ÇAĞRILMAZ —
 * ürünün tek adımlı bir işlemini dört adımlıymış gibi göstermek olmayan bir ilerlemeyi
 * varmış gibi sunardı. Karar sayfa katmanında: akış gerçekten çok adımlıysa `Stepper`
 * kullanılır.
 */
export function Stepper({ steps, current, className }: StepperProps) {
  return (
    <ol className={cn("flex w-full items-center", className)}>
      {steps.map((step, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <li key={step} className="flex flex-1 items-center last:flex-none">
            <span className="flex items-center gap-2.5">
              <span
                aria-hidden="true"
                className={cn(
                  "flex size-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold",
                  active
                    ? "bg-primary text-on-inverse"
                    : done
                      ? "bg-primary-soft text-primary"
                      : "border border-border-default text-fg-muted",
                )}
              >
                {done ? (
                  <svg viewBox="0 0 20 20" fill="currentColor" className="size-4">
                    <path d="M16.7 5.3a1 1 0 0 1 0 1.4l-8 8a1 1 0 0 1-1.4 0l-4-4a1 1 0 1 1 1.4-1.4L8 12.6l7.3-7.3a1 1 0 0 1 1.4 0Z" />
                  </svg>
                ) : (
                  i + 1
                )}
              </span>
              <span
                className={cn(
                  "text-sm whitespace-nowrap",
                  active ? "font-semibold text-fg-strong" : "text-fg-muted",
                )}
                aria-current={active ? "step" : undefined}
              >
                {step}
              </span>
            </span>
            {i < steps.length - 1 ? (
              <span aria-hidden="true" className="mx-3 h-px flex-1 bg-border-default" />
            ) : null}
          </li>
        );
      })}
    </ol>
  );
}
